var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"px-4",attrs:{"color":_vm.color,"outlined":"","ripple":""}},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }